var map = {
	"./assistant/assistant-avatar.png": "993c",
	"./choice-ai/bg-large.png": "3bea",
	"./choice-ai/bg-medium.png": "a20a",
	"./choice-ai/bg-small.png": "0e3f",
	"./cursors/cursor-hand-closed.cur": "5339",
	"./cursors/cursor-hand-closed.png": "3f26",
	"./cursors/cursor-hand-opened.cur": "0107",
	"./cursors/cursor-hand-opened.png": "617e",
	"./cursors/cursor-normal.cur": "df25",
	"./cursors/cursor-normal.png": "87e1",
	"./cursors/cursor-scissors.png": "516f",
	"./cutscene-placeholder.png": "8fce",
	"./cutscene/arrow.svg": "9625",
	"./cutscene/content/1/Desktop/1.png": "a3d4",
	"./cutscene/content/1/Desktop/2.png": "6fe3",
	"./cutscene/content/1/Desktop/3.png": "6462",
	"./cutscene/content/1/Desktop/4.png": "c708",
	"./cutscene/content/1/Desktop/5.png": "f068",
	"./cutscene/content/1/Desktop/6.png": "6289",
	"./cutscene/content/1/Desktop/7.png": "6032",
	"./cutscene/content/1/Mobile/1.png": "5655",
	"./cutscene/content/1/Mobile/2.png": "a8f4",
	"./cutscene/content/1/Mobile/3.png": "1a31",
	"./cutscene/content/1/Mobile/4.png": "bffa",
	"./cutscene/content/1/Mobile/5.png": "485f",
	"./cutscene/content/1/Mobile/6.png": "7774",
	"./cutscene/content/1/Mobile/7.png": "e511",
	"./cutscene/content/1/Mobile/8.png": "02c1",
	"./cutscene/content/1/tablet-1.png": "844e",
	"./cutscene/content/1/tablet-2.png": "2c25",
	"./cutscene/content/2/Desktop/1.png": "6033",
	"./cutscene/content/2/Desktop/2.png": "e43c",
	"./cutscene/content/2/Desktop/3.png": "a6a5",
	"./cutscene/content/2/Desktop/cloud.svg": "2b03",
	"./cutscene/content/2/Mobile/1.png": "64cc",
	"./cutscene/content/2/Mobile/2.png": "0066",
	"./cutscene/content/2/Mobile/3.png": "b2a1",
	"./cutscene/content/2/light.svg": "9c90",
	"./cutscene/content/2/tablet-1.png": "48a7",
	"./cutscene/content/2/tablet-2.png": "aedf",
	"./cutscene/content/3/Desktop/1.png": "095c",
	"./cutscene/content/3/Desktop/2.png": "00d5",
	"./cutscene/content/3/Mobile/1.png": "fb10",
	"./cutscene/content/3/Mobile/2.png": "58c0",
	"./cutscene/content/3/Mobile/Frame 471.png": "e3e7",
	"./cutscene/content/3/tablet-1.png": "d8ff",
	"./cutscene/content/3/tablet-2.png": "39e9",
	"./cutscene/content/4/Desktop/1.png": "f5c2",
	"./cutscene/content/4/Desktop/2.png": "a94c",
	"./cutscene/content/4/Desktop/3.png": "1eb7",
	"./cutscene/content/4/Desktop/4.png": "b501",
	"./cutscene/content/4/Desktop/5.png": "55c4",
	"./cutscene/content/4/Desktop/6.png": "acfc",
	"./cutscene/content/4/Desktop/7.png": "6cfa",
	"./cutscene/content/4/Desktop/bg.svg": "4a47",
	"./cutscene/content/4/Mobile/1.png": "3c60",
	"./cutscene/content/4/Mobile/2.png": "94f9",
	"./cutscene/content/4/Mobile/3.png": "7f64",
	"./cutscene/content/4/Mobile/4.png": "581b",
	"./cutscene/content/4/Mobile/5.png": "0bfd",
	"./cutscene/content/4/Mobile/6.png": "2744",
	"./cutscene/content/4/Mobile/7.png": "78a7",
	"./cutscene/content/4/Mobile/bg.svg": "8c6f",
	"./cutscene/content/4/tablet-1.png": "fd2c",
	"./cutscene/content/4/tablet-2.png": "a013",
	"./cutscene/header-image.png": "9403",
	"./cutscene/left.png": "5663",
	"./cutscene/right.png": "43e9",
	"./dialog/avatar-ai.png": "29f0",
	"./dialog/avatar-assistant.png": "32cc",
	"./dialog/bg-large.svg": "7ad8",
	"./dialog/bg-small.svg": "01d3",
	"./dialog/grid-left-large.svg": "640a",
	"./dialog/grid-left-small.svg": "ef57",
	"./dialog/grid-right-large.svg": "df70",
	"./dialog/grid-right-small.svg": "58dd",
	"./dialog/speaker-left-bg.png": "8603",
	"./dialog/speaker-right-bg.png": "f6c5",
	"./end-screen/bg-large.png": "89252",
	"./end-screen/bg-medium.png": "dda7",
	"./end-screen/bg-small.png": "aa19",
	"./end-screen/certificate-large.png": "6588",
	"./end-screen/certificate-medium.png": "15a6",
	"./end-screen/certificate-small.png": "9cae",
	"./end-screen/frame-large.png": "a760",
	"./end-screen/frame-medium.png": "6169",
	"./end-screen/frame-small.png": "666c",
	"./end-screen/glow-green-large.png": "19cb",
	"./end-screen/glow-green-medium.png": "8b0d",
	"./end-screen/glow-green-small.png": "cd1e",
	"./end-screen/glow-vilolet-large.png": "121b",
	"./end-screen/glow-vilolet-medium.png": "c620",
	"./end-screen/glow-vilolet-small.png": "53ed",
	"./end-screen/glow-yellow-large.png": "060e",
	"./end-screen/glow-yellow-medium.png": "7083",
	"./end-screen/glow-yellow-small.png": "2a65",
	"./end-screen/sparks-yellow-large.png": "584e",
	"./end-screen/sparks-yellow-medium.png": "66ea",
	"./fonts/Gilroy/Gilroy-Black.eot": "3999",
	"./fonts/Gilroy/Gilroy-Black.ttf": "8dc6",
	"./fonts/Gilroy/Gilroy-Black.woff": "1711",
	"./fonts/Gilroy/Gilroy-BlackItalic.eot": "2ac6",
	"./fonts/Gilroy/Gilroy-BlackItalic.ttf": "19cc",
	"./fonts/Gilroy/Gilroy-BlackItalic.woff": "c4e6",
	"./fonts/Gilroy/Gilroy-Bold.eot": "d441",
	"./fonts/Gilroy/Gilroy-Bold.ttf": "a6c7",
	"./fonts/Gilroy/Gilroy-Bold.woff": "e6e2",
	"./fonts/Gilroy/Gilroy-BoldItalic.eot": "9681",
	"./fonts/Gilroy/Gilroy-BoldItalic.ttf": "c7a2",
	"./fonts/Gilroy/Gilroy-BoldItalic.woff": "34d1",
	"./fonts/Gilroy/Gilroy-ExtraBold.eot": "93ac",
	"./fonts/Gilroy/Gilroy-ExtraBold.ttf": "d562",
	"./fonts/Gilroy/Gilroy-ExtraBold.woff": "a8ee",
	"./fonts/Gilroy/Gilroy-ExtraBoldItalic.eot": "878a",
	"./fonts/Gilroy/Gilroy-ExtraBoldItalic.ttf": "27e1",
	"./fonts/Gilroy/Gilroy-ExtraBoldItalic.woff": "93a5",
	"./fonts/Gilroy/Gilroy-Heavy.eot": "a39e",
	"./fonts/Gilroy/Gilroy-Heavy.ttf": "8d24",
	"./fonts/Gilroy/Gilroy-Heavy.woff": "6780",
	"./fonts/Gilroy/Gilroy-HeavyItalic.eot": "acb4",
	"./fonts/Gilroy/Gilroy-HeavyItalic.ttf": "3e13",
	"./fonts/Gilroy/Gilroy-HeavyItalic.woff": "03ba",
	"./fonts/Gilroy/Gilroy-Light.eot": "5b3f",
	"./fonts/Gilroy/Gilroy-Light.ttf": "54ce",
	"./fonts/Gilroy/Gilroy-Light.woff": "a83f",
	"./fonts/Gilroy/Gilroy-LightItalic.eot": "0109",
	"./fonts/Gilroy/Gilroy-LightItalic.ttf": "a51d",
	"./fonts/Gilroy/Gilroy-LightItalic.woff": "d8fe",
	"./fonts/Gilroy/Gilroy-Medium.eot": "d8b4",
	"./fonts/Gilroy/Gilroy-Medium.ttf": "7d6c",
	"./fonts/Gilroy/Gilroy-Medium.woff": "2a2d",
	"./fonts/Gilroy/Gilroy-MediumItalic.eot": "f2bc",
	"./fonts/Gilroy/Gilroy-MediumItalic.ttf": "ff2b",
	"./fonts/Gilroy/Gilroy-MediumItalic.woff": "4ae8",
	"./fonts/Gilroy/Gilroy-Regular.eot": "7427",
	"./fonts/Gilroy/Gilroy-Regular.ttf": "ccbe",
	"./fonts/Gilroy/Gilroy-Regular.woff": "af75",
	"./fonts/Gilroy/Gilroy-RegularItalic.eot": "b1fd",
	"./fonts/Gilroy/Gilroy-RegularItalic.ttf": "0f26",
	"./fonts/Gilroy/Gilroy-RegularItalic.woff": "1f25",
	"./fonts/Gilroy/Gilroy-SemiBold.eot": "f588",
	"./fonts/Gilroy/Gilroy-SemiBold.ttf": "31aa",
	"./fonts/Gilroy/Gilroy-SemiBold.woff": "8431",
	"./fonts/Gilroy/Gilroy-SemiBoldItalic.eot": "2edc",
	"./fonts/Gilroy/Gilroy-SemiBoldItalic.ttf": "b60d",
	"./fonts/Gilroy/Gilroy-SemiBoldItalic.woff": "d3b8",
	"./fonts/Gilroy/Gilroy-Thin.eot": "a750",
	"./fonts/Gilroy/Gilroy-Thin.ttf": "c2e2",
	"./fonts/Gilroy/Gilroy-Thin.woff": "e6f9",
	"./fonts/Gilroy/Gilroy-ThinItalic.eot": "dc8a",
	"./fonts/Gilroy/Gilroy-ThinItalic.ttf": "3022",
	"./fonts/Gilroy/Gilroy-ThinItalic.woff": "cafe",
	"./fonts/Gilroy/Gilroy-UltraLight.eot": "9d37",
	"./fonts/Gilroy/Gilroy-UltraLight.ttf": "7360",
	"./fonts/Gilroy/Gilroy-UltraLight.woff": "7326",
	"./fonts/Gilroy/Gilroy-UltraLightItalic.eot": "4900",
	"./fonts/Gilroy/Gilroy-UltraLightItalic.ttf": "0d49",
	"./fonts/Gilroy/Gilroy-UltraLightItalic.woff": "7430",
	"./fonts/Gilroy/stylesheet.css": "5995",
	"./loader/bg-large.svg": "4779",
	"./loader/bg-medium.svg": "9a50",
	"./loader/bg-small.svg": "9bf3",
	"./loader/frame.png": "d932",
	"./loader/network.png": "f031",
	"./loader/network.svg": "3dc4",
	"./loader/spinner.svg": "67ff",
	"./minigame-1/arrows-left.png": "99a5",
	"./minigame-1/arrows-right.png": "30e6",
	"./minigame-1/assistant-avatar.png": "f714",
	"./minigame-1/bg-huge.png": "8e66",
	"./minigame-1/bg-huge.svg": "03b9",
	"./minigame-1/bg-large.png": "ea75",
	"./minigame-1/bg-large.svg": "f840",
	"./minigame-1/bg-medium.png": "429b",
	"./minigame-1/bg-medium.svg": "fed1",
	"./minigame-1/bg-small.png": "d8d3",
	"./minigame-1/bg-small.svg": "80fe",
	"./minigame-1/content/symbol-1-center.png": "a58f",
	"./minigame-1/content/symbol-1-left.png": "48fb",
	"./minigame-1/content/symbol-1-right.png": "06f4",
	"./minigame-1/content/symbol-15-center.png": "85ac",
	"./minigame-1/content/symbol-15-left.png": "e412",
	"./minigame-1/content/symbol-15-right.png": "3495",
	"./minigame-1/content/symbol-4-center.png": "8a23",
	"./minigame-1/content/symbol-4-left.png": "2146",
	"./minigame-1/content/symbol-4-right.png": "9a13",
	"./minigame-1/content/symbol-45-center.png": "d00f",
	"./minigame-1/content/symbol-45-left.png": "b7bc",
	"./minigame-1/content/symbol-45-right.png": "5155",
	"./minigame-1/content/symbol-6-center.png": "ebd1",
	"./minigame-1/content/symbol-6-left.png": "b950",
	"./minigame-1/content/symbol-6-right.png": "bf4f",
	"./minigame-1/content/symbol-8-center.png": "7f63",
	"./minigame-1/content/symbol-8-left.png": "620a",
	"./minigame-1/content/symbol-8-right.png": "a5d0",
	"./minigame-1/content/symbol-arrow-center.png": "f1d8",
	"./minigame-1/content/symbol-arrow-left.png": "bf6e",
	"./minigame-1/content/symbol-arrow-right.png": "eb31",
	"./minigame-1/content/symbol-calendar-center.png": "3393",
	"./minigame-1/content/symbol-calendar-left.png": "599f",
	"./minigame-1/content/symbol-calendar-right.png": "82b7",
	"./minigame-1/content/symbol-cpp-center.png": "3c9e",
	"./minigame-1/content/symbol-cpp-left.png": "dcb0",
	"./minigame-1/content/symbol-cpp-right.png": "181b",
	"./minigame-1/content/symbol-diy-center.png": "53e9",
	"./minigame-1/content/symbol-diy-left.png": "cfc9",
	"./minigame-1/content/symbol-diy-right.png": "e918",
	"./minigame-1/content/symbol-euro-center.png": "4b61",
	"./minigame-1/content/symbol-euro-left.png": "2754",
	"./minigame-1/content/symbol-euro-right.png": "f44d",
	"./minigame-1/content/symbol-five-thirds-center.png": "b510",
	"./minigame-1/content/symbol-five-thirds-left.png": "430b",
	"./minigame-1/content/symbol-five-thirds-right.png": "0375",
	"./minigame-1/content/symbol-fraction-center.png": "0058",
	"./minigame-1/content/symbol-fraction-left.png": "4648",
	"./minigame-1/content/symbol-fraction-right.png": "2a9d",
	"./minigame-1/content/symbol-fx-center.png": "c53a",
	"./minigame-1/content/symbol-fx-left.png": "1138",
	"./minigame-1/content/symbol-fx-right.png": "e5d6",
	"./minigame-1/content/symbol-hand-center.png": "4aba",
	"./minigame-1/content/symbol-hand-left.png": "3604",
	"./minigame-1/content/symbol-hand-right.png": "cf7c",
	"./minigame-1/content/symbol-hash-center.png": "b7e4",
	"./minigame-1/content/symbol-hash-left.png": "1886",
	"./minigame-1/content/symbol-hash-right.png": "87fb",
	"./minigame-1/content/symbol-i-center.png": "5043",
	"./minigame-1/content/symbol-i-left.png": "1fb3",
	"./minigame-1/content/symbol-i-right.png": "d8ffa",
	"./minigame-1/content/symbol-infinity-center.png": "508e",
	"./minigame-1/content/symbol-infinity-left.png": "c108",
	"./minigame-1/content/symbol-infinity-right.png": "443e",
	"./minigame-1/content/symbol-noteq-center.png": "dcf0",
	"./minigame-1/content/symbol-noteq-left.png": "0d91",
	"./minigame-1/content/symbol-noteq-right.png": "123e",
	"./minigame-1/content/symbol-one-seventh-center.png": "ec6d",
	"./minigame-1/content/symbol-one-seventh-left.png": "1a1e",
	"./minigame-1/content/symbol-one-seventh-right.png": "056e",
	"./minigame-1/content/symbol-quarter-center.png": "6603",
	"./minigame-1/content/symbol-quarter-left.png": "eb13",
	"./minigame-1/content/symbol-quarter-right.png": "6f21",
	"./minigame-1/content/symbol-roman-center.png": "eb70",
	"./minigame-1/content/symbol-roman-left.png": "3ab1",
	"./minigame-1/content/symbol-roman-right.png": "0882",
	"./minigame-1/content/symbol-roman-tl-center.png": "be3a",
	"./minigame-1/content/symbol-roman-tl-left.png": "9d31",
	"./minigame-1/content/symbol-roman-tl-right.png": "ffdd",
	"./minigame-1/content/symbol-sqrt-center.png": "fac0",
	"./minigame-1/content/symbol-sqrt-left.png": "7fb1",
	"./minigame-1/content/symbol-sqrt-right.png": "02e7",
	"./minigame-1/content/symbol-swan-center.png": "ef1d",
	"./minigame-1/content/symbol-swan-left.png": "caec",
	"./minigame-1/content/symbol-swan-right.png": "ab1b",
	"./minigame-1/content/symbol-t-center.png": "2731",
	"./minigame-1/content/symbol-t-left.png": "bde4",
	"./minigame-1/content/symbol-t-right.png": "2107",
	"./minigame-1/content/symbol-theta-center.png": "4cbf",
	"./minigame-1/content/symbol-theta-left.png": "aca7",
	"./minigame-1/content/symbol-theta-right.png": "6869",
	"./minigame-1/content/symbol-time-center.png": "6793",
	"./minigame-1/content/symbol-time-left.png": "4def",
	"./minigame-1/content/symbol-time-right.png": "ea64",
	"./minigame-1/content/symbol-x2-center.png": "f83d",
	"./minigame-1/content/symbol-x2-left.png": "8a39",
	"./minigame-1/content/symbol-x2-right.png": "e29f",
	"./minigame-1/content/symbol-y2-center.png": "1d00",
	"./minigame-1/content/symbol-y2-left.png": "737f",
	"./minigame-1/content/symbol-y2-right.png": "164f",
	"./minigame-1/cursor-hand-closed.png": "c3f4",
	"./minigame-1/cursor-hand-open.png": "e74e",
	"./minigame-1/drop-item-center-active.png": "2170",
	"./minigame-1/drop-item-center-inactive.png": "1738",
	"./minigame-1/drop-item-left-active.png": "b1b0",
	"./minigame-1/drop-item-left-inactive.png": "c82d",
	"./minigame-1/drop-item-right-active.png": "a690",
	"./minigame-1/drop-item-right-inactive.png": "29e0",
	"./minigame-1/drop-item-target.png": "597a",
	"./minigame-1/dropzone-left.png": "e03c",
	"./minigame-1/dropzone-right.png": "d939",
	"./minigame-1/glow-green.svg": "c7f3",
	"./minigame-1/glow-red.svg": "c50c",
	"./minigame-1/holo.svg": "b1c7",
	"./minigame-1/hovered-green.svg": "34bd",
	"./minigame-1/hovered-red.svg": "fb14",
	"./minigame-1/progress-empty.png": "b931",
	"./minigame-1/progress-frame-large.png": "9790",
	"./minigame-1/progress-frame-medium.png": "2510",
	"./minigame-1/progress-frame-small.png": "0da8",
	"./minigame-1/progress-full.png": "0410",
	"./minigame-2/assistant-avatar.png": "34ed",
	"./minigame-2/background_1118.png": "9a76",
	"./minigame-2/background_1920.png": "a26a",
	"./minigame-2/background_2560.png": "2915",
	"./minigame-2/background_568.png": "248d",
	"./minigame-2/content/180_green.png": "b764",
	"./minigame-2/content/180_red.png": "22dd",
	"./minigame-2/content/404_green.png": "a0b2",
	"./minigame-2/content/404_red.png": "b36d",
	"./minigame-2/content/H_green.png": "7d38",
	"./minigame-2/content/H_red.png": "333d",
	"./minigame-2/content/IV_green.png": "d23b",
	"./minigame-2/content/IV_red.png": "62e6",
	"./minigame-2/content/TOT_green.png": "c613",
	"./minigame-2/content/TOT_red.png": "dabc",
	"./minigame-2/content/andor_green.png": "3dd1",
	"./minigame-2/content/andor_red.png": "51c8",
	"./minigame-2/content/calendar_green.png": "da85",
	"./minigame-2/content/calendar_red.png": "a8d4",
	"./minigame-2/content/cpp_green.png": "b0f3",
	"./minigame-2/content/cpp_red.png": "a56d",
	"./minigame-2/content/csharp_green.png": "491c",
	"./minigame-2/content/csharp_red.png": "41a4",
	"./minigame-2/content/eight_green.png": "e2c3",
	"./minigame-2/content/eight_red.png": "c046",
	"./minigame-2/content/eternity_green.png": "5c5d",
	"./minigame-2/content/eternity_red.png": "a8fc",
	"./minigame-2/content/five-thirds-green.png": "64d7",
	"./minigame-2/content/five-thirds-red.png": "5759",
	"./minigame-2/content/formula_green.png": "6458",
	"./minigame-2/content/formula_red.png": "ccee",
	"./minigame-2/content/four_green.png": "4058",
	"./minigame-2/content/four_red.png": "cc49",
	"./minigame-2/content/half_green.png": "c18a",
	"./minigame-2/content/half_red.png": "199e",
	"./minigame-2/content/hand_green.png": "1584",
	"./minigame-2/content/hand_red.png": "932d",
	"./minigame-2/content/hundred_green.png": "7c48",
	"./minigame-2/content/hundred_red.png": "0bea",
	"./minigame-2/content/i_green.png": "457f",
	"./minigame-2/content/i_red.png": "c20b",
	"./minigame-2/content/it_green.png": "adb0",
	"./minigame-2/content/it_red.png": "6da5",
	"./minigame-2/content/less3_green.png": "7eff",
	"./minigame-2/content/less3_red.png": "b351",
	"./minigame-2/content/nine_red.png": "2a52",
	"./minigame-2/content/noteq_green.png": "dbed",
	"./minigame-2/content/noteq_red.png": "218c",
	"./minigame-2/content/one_green.png": "2bd7",
	"./minigame-2/content/one_red.png": "89ad",
	"./minigame-2/content/puff_green.png": "c9fe",
	"./minigame-2/content/puff_red.png": "f1e7",
	"./minigame-2/content/six_green.png": "c807",
	"./minigame-2/content/six_red.png": "5fbf",
	"./minigame-2/content/speed_green.png": "f528",
	"./minigame-2/content/speed_red.png": "58ab",
	"./minigame-2/content/sqrt-left.png": "1535",
	"./minigame-2/content/sqrt-right.png": "75cb",
	"./minigame-2/content/swan_green.png": "31b1",
	"./minigame-2/content/swan_red.png": "84f8",
	"./minigame-2/content/symbols_green.png": "7b8b",
	"./minigame-2/content/symbols_red.png": "b96f",
	"./minigame-2/content/theta_green.png": "be66",
	"./minigame-2/content/theta_red.png": "8c08",
	"./minigame-2/content/third_green.png": "56d5",
	"./minigame-2/content/third_red.png": "1be1",
	"./minigame-2/cursor_hand_closed.png": "0976",
	"./minigame-2/cursor_hand_opened.png": "c244",
	"./minigame-2/cursor_normal.png": "8b07",
	"./minigame-2/destination-glow.svg": "f5b6",
	"./minigame-2/destination_glow.png": "e8ad",
	"./minigame-2/green_item.png": "b9d6",
	"./minigame-2/green_item_hovered.png": "d6a3",
	"./minigame-2/hovered.svg": "08da",
	"./minigame-2/not_numbers_correct.png": "fd00",
	"./minigame-2/not_numbers_incorrect.png": "d04a",
	"./minigame-2/numbers_correct.png": "ddd7",
	"./minigame-2/numbers_incorrect.png": "b721",
	"./minigame-2/red_item.png": "76cc",
	"./minigame-2/red_item_hovered.png": "d4da",
	"./minigame-3/bg-large.svg": "8c5b",
	"./minigame-3/bg-medium.svg": "70b5",
	"./minigame-3/bg-small.svg": "89ad1",
	"./minigame-3/content/essay-db-active.png": "9a7c",
	"./minigame-3/content/essay-db-inactive.png": "bec2",
	"./minigame-3/content/function-graphs-active.png": "0a43",
	"./minigame-3/content/function-graphs-inactive.png": "f661",
	"./minigame-3/content/maths-exercises-active.png": "17ac",
	"./minigame-3/content/maths-exercises-inactive.png": "9980",
	"./minigame-3/content/maths-textbook-active.png": "d01b",
	"./minigame-3/content/maths-textbook-inactive.png": "d689",
	"./minigame-3/content/multiplication-table-active.png": "378c",
	"./minigame-3/content/multiplication-table-inactive.png": "a754",
	"./minigame-3/content/pen-and-rubber-active.png": "0d5e",
	"./minigame-3/content/pen-and-rubber-inactive.png": "e94d",
	"./minigame-3/content/roots-and-herbs-active.png": "5a78",
	"./minigame-3/content/roots-and-herbs-inactive.png": "003e",
	"./minigame-3/content/spelling-textbook-active.png": "f4dd",
	"./minigame-3/content/spelling-textbook-inactive.png": "2a08",
	"./minigame-3/content/teacher_db_active.png": "2971",
	"./minigame-3/content/teacher_db_inactive.png": "b91d",
	"./minigame-3/content/trig-textbook-active.png": "78e5",
	"./minigame-3/content/trig-textbook-inactive.png": "f906",
	"./minigame-3/cursor-drag-node.cur": "d777",
	"./minigame-3/cursor-drag-node.png": "fa91",
	"./minigame-3/hovered.svg": "3b62",
	"./minigame-3/item-anchor.png": "5d2e",
	"./minigame-3/item-top-active.png": "c21d",
	"./minigame-3/item-top-inactive.png": "b472",
	"./minigame-3/target-inactive.png": "2a37",
	"./minigame-4/addition.png": "f01c",
	"./minigame-4/arrow.png": "333b",
	"./minigame-4/bg-l.png": "c43e",
	"./minigame-4/bg-m.png": "89fb",
	"./minigame-4/bg-s.png": "e501",
	"./minigame-4/bg-xl.png": "5def",
	"./minigame-4/bg-xs.png": "92ca",
	"./minigame-4/block-diagram-container-hovered.png": "c96d",
	"./minigame-4/block-diagram-container.png": "e3d8",
	"./minigame-4/comparison.png": "47b7",
	"./minigame-4/division.png": "45b9",
	"./minigame-4/dot-green.png": "c8bd",
	"./minigame-4/dot-red.png": "4073",
	"./minigame-4/dot-yellow.png": "6f95",
	"./minigame-4/equations-square.png": "ba2a",
	"./minigame-4/equations.png": "8791",
	"./minigame-4/fractions.png": "dee8",
	"./minigame-4/functions.png": "49b0",
	"./minigame-4/glow-blue-large.png": "c4aa",
	"./minigame-4/glow-blue-medium.png": "721e",
	"./minigame-4/glow-blue-small.png": "30af",
	"./minigame-4/glow-green-large.png": "35d2",
	"./minigame-4/glow-green-medium.png": "9efa",
	"./minigame-4/glow-green-small.png": "ab0b",
	"./minigame-4/glow-yellow-large.png": "41c4",
	"./minigame-4/glow-yellow-medium.png": "3869",
	"./minigame-4/glow-yellow-small.png": "1176",
	"./minigame-4/multiplication.png": "68c7",
	"./minigame-4/result-container.png": "1b18",
	"./minigame-4/sparks-green-large.png": "3ed1",
	"./minigame-4/sparks-green-medium.png": "ed33",
	"./minigame-4/sparks-green-small.png": "86a6",
	"./minigame-4/sparks-yellow-large.png": "4017",
	"./minigame-4/sparks-yellow-medium.png": "94d3",
	"./minigame-4/sparks-yellow-small.png": "7714",
	"./minigame-4/subtraction.png": "3159",
	"./minigame-4/systems.png": "5e8e",
	"./minigame-4/update-ai-button-hovered.png": "eca4",
	"./minigame-4/update-ai-button.png": "8221",
	"./minigame-5/add.png": "df0e",
	"./minigame-5/bg-large.svg": "2502",
	"./minigame-5/bg-medium.svg": "6c16",
	"./minigame-5/bg-small.svg": "1319",
	"./minigame-5/block-center-large.png": "ab7b",
	"./minigame-5/block-center-medium.png": "e3ff",
	"./minigame-5/block-center-small.png": "85b0",
	"./minigame-5/block-left-large.png": "9893",
	"./minigame-5/block-left-medium.png": "0fc1",
	"./minigame-5/block-left-small.png": "c683",
	"./minigame-5/block-right-large.png": "5f48",
	"./minigame-5/block-right-medium.png": "7556",
	"./minigame-5/block-right-small.png": "00ef",
	"./minigame-5/compare.png": "9b53",
	"./minigame-5/cursor-drag-node.cur": "d385",
	"./minigame-5/cursor-drag-node.png": "31b1e",
	"./minigame-5/divide.png": "7c80",
	"./minigame-5/equations-square.png": "b036",
	"./minigame-5/equations.png": "3ea7",
	"./minigame-5/fractions.png": "71da",
	"./minigame-5/functions.png": "53fe",
	"./minigame-5/glitter-green.png": "f2ab",
	"./minigame-5/glitter-yellow.png": "adb6",
	"./minigame-5/hovered-green.svg": "e01c",
	"./minigame-5/hovered-yellow.svg": "6ad7",
	"./minigame-5/multiply.png": "b847",
	"./minigame-5/subtract.png": "d780",
	"./minigame-5/systems.png": "29e7",
	"./minigame-6/bg-large.png": "548a",
	"./minigame-6/bg-medium.png": "521e",
	"./minigame-6/bg-small.png": "a684",
	"./minigame-6/check.svg": "25e9",
	"./minigame-6/content/add-1.svg": "4e79",
	"./minigame-6/content/add-2.svg": "947e",
	"./minigame-6/content/add-3.svg": "140c",
	"./minigame-6/content/add-4.svg": "811c",
	"./minigame-6/content/compare-1.svg": "f3fef",
	"./minigame-6/content/compare-2.svg": "554f",
	"./minigame-6/content/compare-3.svg": "bab6",
	"./minigame-6/content/divide14-1.svg": "3514",
	"./minigame-6/content/divide14-2.svg": "3ad7",
	"./minigame-6/content/divide14-3.svg": "6939",
	"./minigame-6/content/divide14-4.svg": "0c1e",
	"./minigame-6/content/divide58-1.svg": "86ac",
	"./minigame-6/content/divide58-2.svg": "9a86",
	"./minigame-6/content/divide58-3.svg": "d69a",
	"./minigame-6/content/equation-1.svg": "2bb0",
	"./minigame-6/content/equation-2.svg": "7b76",
	"./minigame-6/content/equation-3.svg": "7863",
	"./minigame-6/content/equation_sqr1-1.svg": "6a86",
	"./minigame-6/content/equation_sqr1-2.svg": "5486",
	"./minigame-6/content/equation_sqr1-3.svg": "36e7",
	"./minigame-6/content/equation_sqr2-1.svg": "79e9",
	"./minigame-6/content/equation_sqr2-2.svg": "3075",
	"./minigame-6/content/equation_sqr2-3.svg": "4bec",
	"./minigame-6/content/equation_sqr3-1.svg": "4d7e",
	"./minigame-6/content/equation_sqr3-2.svg": "bcd7",
	"./minigame-6/content/equation_sqr3-3.svg": "6dec",
	"./minigame-6/content/fraction1-1.svg": "7f11",
	"./minigame-6/content/fraction1-2.svg": "e66f",
	"./minigame-6/content/fraction1-3.svg": "9357",
	"./minigame-6/content/fraction2-1.svg": "4a9a",
	"./minigame-6/content/fraction2-2.svg": "cbac",
	"./minigame-6/content/fraction2-3.svg": "4e17",
	"./minigame-6/content/fraction3-1.svg": "e275",
	"./minigame-6/content/fraction3-2.svg": "f00a",
	"./minigame-6/content/fraction3-3.svg": "f7ef",
	"./minigame-6/content/function1-1.svg": "e65b",
	"./minigame-6/content/function1-2.svg": "1824",
	"./minigame-6/content/function1-3.svg": "66c6",
	"./minigame-6/content/function2-1.svg": "3b21",
	"./minigame-6/content/function2-2.svg": "f853",
	"./minigame-6/content/function2-3.svg": "deed",
	"./minigame-6/content/function3-1.svg": "65fd",
	"./minigame-6/content/function3-2.svg": "3741",
	"./minigame-6/content/function3-3.svg": "5645",
	"./minigame-6/content/multiply14-1.svg": "1abf",
	"./minigame-6/content/multiply14-2.svg": "cfaa",
	"./minigame-6/content/multiply14-3.svg": "ac6e",
	"./minigame-6/content/multiply14-4.svg": "c6f9",
	"./minigame-6/content/multiply58-1.svg": "b812",
	"./minigame-6/content/multiply58-2.svg": "b0a7",
	"./minigame-6/content/multiply58-3.svg": "b1ae",
	"./minigame-6/content/subtract-1.svg": "009b",
	"./minigame-6/content/subtract-2.svg": "436d",
	"./minigame-6/content/subtract-3.svg": "7bdc",
	"./minigame-6/content/subtract-4.svg": "0a2c",
	"./minigame-6/content/system1-1.svg": "dd03",
	"./minigame-6/content/system1-2.svg": "b477",
	"./minigame-6/content/system1-3.svg": "a275",
	"./minigame-6/content/system2-1.svg": "5f85",
	"./minigame-6/content/system2-2.svg": "6761",
	"./minigame-6/content/system2-3.svg": "8947",
	"./minigame-6/content/system3-1.svg": "545a",
	"./minigame-6/content/system3-2.svg": "1564",
	"./minigame-6/content/system3-3.svg": "953e",
	"./minigame-6/error-large.png": "b8fb",
	"./minigame-6/error-medium.png": "c489",
	"./minigame-6/error-small.png": "d879",
	"./minigame-6/frame-advice-l.png": "97bf",
	"./minigame-6/frame-advice-m.png": "fa59",
	"./minigame-6/frame-advice-s.png": "ce2c",
	"./minigame-6/frame-advice-xl.png": "dc4a",
	"./minigame-6/frame-data-l.png": "70b1",
	"./minigame-6/frame-data-m.png": "f434",
	"./minigame-6/frame-data-s.png": "1704",
	"./minigame-6/frame-data-xl.png": "b74a",
	"./minigame-6/frame-test-l.png": "4196",
	"./minigame-6/frame-test-m.png": "43c3",
	"./minigame-6/frame-test-s.png": "4f97",
	"./minigame-6/frame-test-xl.png": "fc6b",
	"./minigame-6/glow-green-large.png": "73f1",
	"./minigame-6/glow-green-medium.png": "08f8",
	"./minigame-6/glow-green-small.png": "0863",
	"./minigame-6/glow-yellow1-large.png": "1836",
	"./minigame-6/glow-yellow1-medium.png": "b6fc",
	"./minigame-6/glow-yellow1-small.png": "30d2",
	"./minigame-6/glow-yellow2-large.png": "9e04",
	"./minigame-6/glow-yellow2-medium.png": "38cd",
	"./minigame-6/glow-yellow2-small.png": "e330",
	"./minigame-6/sparks-green-large.png": "9200",
	"./minigame-6/sparks-green-medium.png": "4193",
	"./minigame-6/sparks-green-small.png": "2bdc",
	"./minigame-6/sparks-yellow-large.png": "39a6",
	"./minigame-6/sparks-yellow-medium.png": "de4b",
	"./minigame-6/sparks-yellow-small.png": "ecb4",
	"./questionnaire/plus.svg": "5063",
	"./questionnaire/select-arrow.svg": "64b1",
	"./scanner/arrow-pin-large.png": "4535",
	"./scanner/arrow-pin-medium.png": "fd04",
	"./scanner/arrow-pin-small.png": "b33f",
	"./scanner/arrow-pin-xsmall.png": "49ac",
	"./scanner/avatar-ai.png": "e6d4",
	"./scanner/beam.png": "fa03",
	"./scanner/bg-large.png": "625b",
	"./scanner/bg-medium.png": "5dfa",
	"./scanner/bg-small.png": "caa3",
	"./scanner/block-graphs.png": "bd7c",
	"./scanner/block-numbers.png": "c028",
	"./scanner/block-result.png": "61a7",
	"./scanner/content/sheet-1-4.png": "8a46",
	"./scanner/content/sheet-5-7.png": "c3e3",
	"./scanner/content/sheet-8-11-1.png": "a3e5",
	"./scanner/content/sheet-8-11-2.png": "ad6b",
	"./scanner/content/sheet-8-11-3.png": "6523",
	"./scanner/content/test-1-4-1.png": "a157",
	"./scanner/content/test-1-4-2.png": "96e9",
	"./scanner/content/test-1-4-3.png": "bcb2",
	"./scanner/content/test-1-4-4.png": "7686",
	"./scanner/content/test-5-8-1.png": "7deb",
	"./scanner/content/test-5-8-2-glitch.png": "17dc",
	"./scanner/content/test-5-8-2.png": "0203",
	"./scanner/content/test-5-8-3-glitch.png": "63b6",
	"./scanner/content/test-5-8-3.png": "3412",
	"./scanner/content/test-5-8-4-glitch.png": "dbe9",
	"./scanner/content/test-5-8-4.png": "3e5d",
	"./scanner/content/test-8-11-3.png": "b856",
	"./scanner/content/test-9-11-1.png": "302c",
	"./scanner/content/test-9-11-2-glitch.png": "c725",
	"./scanner/content/test-9-11-2.png": "8e4c",
	"./scanner/content/test-9-11-3.png": "9c37",
	"./scanner/content/test-9-11-4-glitch.png": "c395",
	"./scanner/content/test-9-11-4.png": "1876",
	"./scanner/error-corner.svg": "1352",
	"./scanner/error.svg": "02d3",
	"./scanner/frame-bg.png": "aff2",
	"./scanner/frame.png": "7827",
	"./scanner/glow-green-l.png": "094f",
	"./scanner/glow-green-m.png": "724b",
	"./scanner/glow-green-s.png": "7f94",
	"./scanner/glow-green-xs.png": "ad8f",
	"./scanner/glow-yellow.png": "e07c",
	"./scanner/scanner.png": "f4a3",
	"./scanner/sparks-green-l.png": "93d2",
	"./scanner/sparks-green-m.png": "5934",
	"./scanner/sparks-green-s.png": "1bd3",
	"./scanner/sparks-green-xs.png": "d8d7",
	"./scanner/success.svg": "65b9",
	"./scanner/warning.svg": "c4ad",
	"./stage-intro/bg-large.svg": "83f9",
	"./stage-intro/bg-small.svg": "0ea8",
	"./stage-intro/button-glow.png": "c1d2",
	"./stage-loader/bg-large.svg": "d03b",
	"./stage-loader/bg-medium.svg": "c8ad",
	"./stage-loader/bg-small.svg": "b2f8",
	"./stage-loader/spinner.svg": "2aa4",
	"./stage-result/bg-large.svg": "0484",
	"./stage-result/bg-small.svg": "59d1",
	"./stage-result/button-glow.png": "f5f0",
	"./stage-result/one-star.svg": "58ff",
	"./stage-result/three-stars.svg": "1993",
	"./stage-result/two-stars.svg": "cb1f",
	"./toaster.jpg": "9390",
	"./tutor/arrow-double.png": "a4da",
	"./tutor/arrow-single.png": "f068f",
	"./tutor/bg-large.svg": "ee91",
	"./tutor/bg-medium.svg": "09b8",
	"./tutor/bg-small.svg": "b840",
	"./tutor/button-glow.png": "36e71",
	"./tutor/content/level-1-1.png": "7feb",
	"./tutor/content/level-1-2.png": "2bb3",
	"./tutor/content/level-1-3.png": "2801",
	"./tutor/content/level-2-1.png": "b075",
	"./tutor/content/level-2-2.png": "5b05",
	"./tutor/content/level-2-3.png": "0afe",
	"./tutor/content/level-3-1.png": "aa40",
	"./tutor/content/level-3-2.png": "00ab",
	"./tutor/content/level-3-3.png": "198f",
	"./tutor/stage-bg.png": "800d",
	"./tutor/stage-glitter.png": "6383",
	"./tutor/stage-glow-ne.png": "95b2",
	"./tutor/stage-glow-sw.png": "d955"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";